export class LanternPhysicsManager {
  constructor(pivots) {
    this.pivots = pivots
    this.states = pivots.map(() => ({
      angle: 0,
      velocity: 0,
      yAngle: (Math.random() - 0.5) * 0.1,
      yVelocity: 0,
      damping: 0.95,
      returnSpeed: 0.02
    }))

    this.offsetX = 0
    this.offsetY = 0.66
    this.offsetZ = 0
  }

  update() {
    for (let i = 0; i < this.pivots.length; i++) {
      const state = this.states[i]
      const pivot = this.pivots[i]

      state.angle += state.velocity
      state.velocity *= state.damping
      state.velocity -= state.angle * state.returnSpeed

      state.yAngle += state.yVelocity
      state.yVelocity *= state.damping
      state.yVelocity -= state.yAngle * state.returnSpeed

      pivot.rotation.x = state.angle + this.offsetX
      pivot.rotation.y = state.yAngle + this.offsetY
      pivot.rotation.z = this.offsetZ
    }
  }

  applyImpulse(index, force) {
    if (this.states[index]) {
      this.states[index].velocity += force
      this.states[index].yVelocity += force * 0.3
    }
  }

  destroy() {
    this.pivots = []
    this.states = []
  }
}
